import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {TISA_WICKET_V2_API_URL} from '../tisa-wicket.providers';
import {WicketUserActivity} from '@tisa-group/models';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WicketUserActivityService {
  constructor(
    protected readonly httpClient: HttpClient,
    @Inject(TISA_WICKET_V2_API_URL) readonly wicketV2Url: string | (() => string),
  ) {}

  postUserActivity(data: WicketUserActivity): Observable<null> {
    return this.httpClient.post<null>(
      `${
        this.wicketV2Url instanceof Function ? this.wicketV2Url() : this.wicketV2Url
      }/data/user/activity`,
      data,
    );
  }
}
